import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.SEARCH = function (state, payload) {
  state.scanRecordList = payload.results
}
mutations.CLEAR = function (state, payload) {
  state.scanRecordList = []
}

const state = {
  scanRecordList: []
}
const actions = {
  init: ({ commit, state }, cond) => {
    console.debug('called M0301ScanRecord init')
    return client.postData({ data: { init: { api: 'M0301ScanRecordService.getInit', input: cond } } })
      .then((data) => {
        if (data.init.output.status === false) { throw new Error(data.init.output.message) } else {
          commit('FIND_ALL', data.init.output)
        }
      }).catch((err) => { throw err })
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0301ScanRecord search')
    return client.postData({ data: { search: { api: 'M0301ScanRecordService.searchScanRecord', input: condition } } })
      .then((data) => {
        if (data.search.output.status === false) { throw new Error(data.search.output.message) } else {
          commit('SEARCH', { results: data.search.output })
        }
      }).catch((err) => { throw err })
  },
  clear: ({ commit, state }, condition) => {
    console.debug('called M0301ScanRecord clear')
    commit('CLEAR')
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
